module.exports = __webpack_public_path__ + "static/media/pm_hc_products3.180cbefd.png";